
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-members/[member]",
      function () {
        return require("private-next-pages/team-members/[member].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-members/[member]"])
      });
    }
  